// @flow
import styled from 'styled-components';

export const Inner = styled.div`
  position: relative;
  z-index: 20;

  > div {
    ${({ bottomMargin }) => bottomMargin && `margin-bottom: 42px;`}
  }
`;
